(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ombre-currency-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ombre-currency-selector')) {
    class OmbreCurrencySelector extends HTMLElement {
      connectedCallback() {
        if (this.onDocumentClick) return;

        this.details = this.querySelector('details');
        if (!this.details) return;

        this.onDocumentClick = (event) => {
          if (this.details.open && !this.contains(event.target)) {
            this.details.open = false;
          }
        };

        this.onKeydown = (event) => {
          if (event.key !== 'Escape' || !this.details.open) return;
          this.details.open = false;
          this.details.querySelector('summary')?.focus();
        };

        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        if (this.onDocumentClick) {
          document.removeEventListener('click', this.onDocumentClick);
        }
        if (this.onKeydown) {
          this.removeEventListener('keydown', this.onKeydown);
        }
        this.onDocumentClick = null;
        this.onKeydown = null;
      }
    }

    customElements.define('ombre-currency-selector', OmbreCurrencySelector);
  }
  } catch(e) { console.error(e); }
})();

})();
